import React from "react";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import { ReactComponent as Chatbots } from "../../../assets/images/icons/chatbots.svg";
import { ReactComponent as CodeReview } from "../../../assets/images/icons/codereview.svg";
import { ReactComponent as DocumentAnalysis } from "../../../assets/images/icons/documentanalysis.svg";
import { ReactComponent as Forecast } from "../../../assets/images/icons/forecast.svg";
import { ReactComponent as FraudDetector } from "../../../assets/images/icons/protection.svg";
import { ReactComponent as NoiseCancelling } from "../../../assets/images/icons/noisecancelling.svg";
import { ReactComponent as PersonalAssistant } from "../../../assets/images/icons/personalassistant.svg";
import { ReactComponent as PersonalizedRecommendations } from "../../../assets/images/icons/personalizedrecommendations.svg";
import { ReactComponent as Search } from "../../../assets/images/icons/search.svg";
import { ReactComponent as TextAnalytics } from "../../../assets/images/icons/textanalytics.svg";
import { ReactComponent as TextSummarize } from "../../../assets/images/icons/textsummarize.svg";
import { ReactComponent as TextToSpeech } from "../../../assets/images/icons/texttospeech.svg";
import { ReactComponent as SpeechToText } from "../../../assets/images/icons/speechtotext.svg";
import { ReactComponent as Translation } from "../../../assets/images/icons/translation.svg";
import { ReactComponent as UIdesign } from "../../../assets/images/icons/uidesign.svg";
import { ReactComponent as Image } from "../../../assets/images/icons/image.svg";
import { ReactComponent as HostAssistant } from "../../../assets/images/icons/hostassistant.svg";
import { ReactComponent as WritingAssistant } from "../../../assets/images/icons/writingassistant.svg";
import { ReactComponent as Home } from "../../../assets/images/icons/aihome.svg";
import { ReactComponent as OS } from "../../../assets/images/icons/os.svg";
import { ReactComponent as Game } from "../../../assets/images/icons/game.svg";
import { ReactComponent as FileManagement } from "../../../assets/images/icons/filemanagement.svg";
import { ReactComponent as Texture } from "../../../assets/images/icons/texture.svg";
import { ReactComponent as Factory } from "../../../assets/images/icons/factory.svg";
import { ReactComponent as MotionControl } from "../../../assets/images/icons/motion.svg";
import { ReactComponent as MachineController } from "../../../assets/images/icons/machine.svg";
import { ReactComponent as LogisticAutomation } from "../../../assets/images/icons/logistics.svg";
import { ReactComponent as StockAnalysis } from "../../../assets/images/icons/stock.svg";
import { ReactComponent as SmartCameras } from "../../../assets/images/icons/smartcams.svg";
import { ReactComponent as ProcessOptimization } from "../../../assets/images/icons/processoptimization.svg";
import { ReactComponent as MachineCalibration } from "../../../assets/images/icons/calibration.svg";
import { ReactComponent as PredictiveIntelligence } from "../../../assets/images/icons/predictiveintelligence.svg";
import { ReactComponent as MediatedConversations } from "../../../assets/images/icons/mediatedconversations.svg";
import { ReactComponent as Metrics } from "../../../assets/images/icons/metrics.svg";
import { ReactComponent as CustomerService } from "../../../assets/images/icons/customerservice.svg";
import { ReactComponent as DataIntelligence } from "../../../assets/images/icons/dataintelligence.svg";
import { ReactComponent as CallTracking } from "../../../assets/images/icons/calltracking.svg";
import { ReactComponent as AiVoices } from "../../../assets/images/icons/aivoices.svg";
import { ReactComponent as SoundCreation } from "../../../assets/images/icons/soundcreation.svg";
import { ReactComponent as MediaOptimize } from "../../../assets/images/icons/mediaoptimize.svg";
import { ReactComponent as VideoEdit } from "../../../assets/images/icons/videoedit.svg";
import { ReactComponent as VideoCreation } from "../../../assets/images/icons/videocreation.svg";
import { ReactComponent as ImageInhancer } from "../../../assets/images/icons/imageinhancer.svg";
import { ReactComponent as AudioEditing } from "../../../assets/images/icons/audioediting.svg";
import { ReactComponent as Objects } from "../../../assets/images/icons/objects.svg";
import { ReactComponent as MediaTool } from "../../../assets/images/icons/settings.svg";
import { ReactComponent as LanguageLearn } from "../../../assets/images/icons/languagelearn.svg";
import { ReactComponent as VisualAi } from "../../../assets/images/icons/visualai.svg";
import { ReactComponent as AutomatedML } from "../../../assets/images/icons/automatedml.svg";
import { ReactComponent as Jumpstart } from "../../../assets/images/icons/jumpstart.svg";
import { ReactComponent as Explanations } from "../../../assets/images/icons/explanations.svg";
import { ReactComponent as Clarify } from "../../../assets/images/icons/clarify.svg";
import { ReactComponent as TrainingCertification } from "../../../assets/images/icons/traincertificate.svg";
import { ReactComponent as GetStarted } from "../../../assets/images/icons/getstarted.svg";
import { ReactComponent as Documentation } from "../../../assets/images/icons/documentation.svg";
import { ReactComponent as Blog } from "../../../assets/images/icons/blog.svg";
import { ReactComponent as CaseStudies } from "../../../assets/images/icons/casestudies.svg";
import { ReactComponent as PlatformOverview } from "../../../assets/images/icons/platformoverview.svg";
import { ReactComponent as TrustCenter } from "../../../assets/images/icons/trustcenter.svg";
import { ReactComponent as Webinars } from "../../../assets/images/icons/webinars.svg";
import { ReactComponent as News } from "../../../assets/images/icons/news.svg";
import { ReactComponent as Healthcare } from "../../../assets/images/icons/healthcare.svg";
import { ReactComponent as Banking } from "../../../assets/images/icons/banking.svg";
import { ReactComponent as Advertising } from "../../../assets/images/icons/advertising.svg";
import { ReactComponent as CommunicationServices } from "../../../assets/images/icons/communicationservices.svg";
import { ReactComponent as LifeSciences } from "../../../assets/images/icons/lifesciences.svg";
import { ReactComponent as Retail } from "../../../assets/images/icons/retail.svg";
import { ReactComponent as Manufacturing } from "../../../assets/images/icons/manufacturing.svg";
import { ReactComponent as Media } from "../../../assets/images/icons/media.svg";
import { ReactComponent as Energy } from "../../../assets/images/icons/energy.svg";
import { ReactComponent as Education } from "../../../assets/images/icons/education.svg";
import { ReactComponent as Automotive } from "../../../assets/images/icons/automotive.svg";
import { ReactComponent as Enterprise } from "../../../assets/images/icons/enterprisetech.svg";
import { ReactComponent as Gaming } from "../../../assets/images/icons/gaming.svg";
import { ReactComponent as Government } from "../../../assets/images/icons/government.svg";
import { ReactComponent as Travel } from "../../../assets/images/icons/travel.svg";
import { ReactComponent as RecommendationsEngine } from "../../../assets/images/icons/recommendationengines.svg";
import { ReactComponent as CustomerSegmentation } from "../../../assets/images/icons/customersegmentation.svg";
// import { ReactComponent as AdEffectiveness } from "../../../assets/images/icons/adeffectiveness.svg";
import { ReactComponent as PredictiveMaintenance } from "../../../assets/images/icons/predictivemaintenance.svg";
import { ReactComponent as DataVisualization } from "../../../assets/images/icons/datavisualization.svg";
import { ReactComponent as DiseasePrediction } from "../../../assets/images/icons/diseaseprediction.svg";
import { ReactComponent as Tasks } from "../../../assets/images/icons/tasks.svg";
import { ReactComponent as Anomaly } from "../../../assets/images/icons/anomaly.svg";
import { ReactComponent as FileStoring } from "../../../assets/images/icons/filestoring.svg";
import { ReactComponent as DeceptionSecurity } from "../../../assets/images/icons/deception.svg";
import { ReactComponent as CustomerRetention } from "../../../assets/images/icons/customerretention.svg";
import { ReactComponent as PerformanceManagement } from "../../../assets/images/icons/performancemanagement.svg";
import { ReactComponent as CriminalDetection } from "../../../assets/images/icons/criminaldetection.svg";
import { ReactComponent as PredictiveSales } from "../../../assets/images/icons/predictivesales.svg";
import { ReactComponent as Developer } from "../../../assets/images/icons/hostaidev.svg";
import { ReactComponent as Agriculture } from "../../../assets/images/icons/agriculture.svg";
import { ReactComponent as Wildlife } from "../../../assets/images/icons/wildlife.svg";
import { ReactComponent as Forest } from "../../../assets/images/icons/forest.svg";
import { ReactComponent as Farming } from "../../../assets/images/icons/farming.svg";
import { ReactComponent as Nature } from "../../../assets/images/icons/nature.svg";
import { ReactComponent as AirQuality } from "../../../assets/images/icons/airquality.svg";
import { ReactComponent as GeoAnalytics } from "../../../assets/images/icons/geoanalytics.svg";
import { ReactComponent as Geographic } from "../../../assets/images/icons/geographic.svg";
import { ReactComponent as Scientific } from "../../../assets/images/icons/scientific.svg";
import { ReactComponent as Sanscript } from "../../../assets/images/icons/sanscript.svg";
import { ReactComponent as Runes } from "../../../assets/images/icons/runes.svg";

export const SidebarData = [
  {
    title: "Products",
    iconClosed: <ExpandMore style={{ width: "20px", height: "20px" }} />,
    iconOpened: <ExpandLess style={{ width: "20px", height: "20px" }} />,

    subNav: [
      {
        icon: <Chatbots />,
        title: "Communication Bots",
        path: "/chatbots",
      },
      {
        icon: <PersonalAssistant />,
        title: "Personal Assistant",
        path: "/personalassistant",
      },
      {
        icon: <TextAnalytics />,
        title: "Text Analytics",
        path: "/textanalytics",
      },
      {
        icon: <CodeReview />,
        title: "Code Review",
        path: "/code-review",
      },
      {
        icon: <NoiseCancelling />,
        title: "Noise Cancelling",
        path: "/noisecancelling",
      },
      {
        icon: <Search />,
        title: "Enterprise Search",
        path: "/enterprisesearch",
      },
      {
        icon: <TextToSpeech />,
        title: "Text to Speech",
        path: "/texttospeech",
      },
      {
        icon: <Image />,
        title: "Image and Video Analysis",
        path: "/imageanalysis",
      },
      {
        icon: <Translation />,
        title: "Translate AI",
        path: "/translateai",
      },
      {
        icon: <TextSummarize />,
        title: "Text Summarize",
        path: "/text-summarize",
      },
      {
        icon: <PersonalizedRecommendations />,
        title: "Personalized Recommendations ",
        path: "/personalizedrecommendations",
      },
      {
        icon: <Forecast />,
        title: "HostAI Forecast",
        path: "/forecast",
      },
      {
        icon: <FraudDetector />,
        title: "Fraud Detector",
        path: "/frauddetector",
      },
      {
        icon: <DocumentAnalysis />,
        title: "Document Analysis",
        path: "/documentanalysis",
      },
      {
        icon: <UIdesign />,
        title: "UI Design Automation",
        path: "/uidesign",
      },
    ],
  },
  {
    title: "Solutions",
    iconClosed: <ExpandMore style={{ width: "20px", height: "20px" }} />,
    iconOpened: <ExpandLess style={{ width: "20px", height: "20px" }} />,

    subNav: [
      {
        title: "Healthcare",
        path: "/chatbots",
        icon: <Healthcare />,
      },
      {
        title: "Banking & Financial Services",
        path: "/personal-assistant",
        icon: <Banking />,
      },
      {
        title: "Advertising & Marketing",
        path: "/advanced-text-analytics",
        icon: <Advertising />,

      },
      {
        icon: <CommunicationServices />,
        title: "Communication Services ",
        path: "/automated-code-review",
      },
      {
        title: "Life Sciences",
        path: "/noise-cancelling",
        icon: <LifeSciences />,
      },
      {
        icon: <Retail />,
        title: "Retail & Ecommerce ",
        path: "/enterprise-search",
      },
      {
        icon: <Manufacturing />,
        title: "Manufacturing",
        path: "/text-to-speech",
      },
      {
        icon: <Media />,
        title: "Media & Entertainment",
        path: "/image-video-analysis",
      },
      {
        icon: <Energy />,
        title: "Energy & Utilities",
        path: "/real-time-translation",
      },
      {
        icon: <Education />,
        title: "Education",
        path: "/text-summarize",
      },
      {
        icon: <Automotive />,
        title: "Automotive",
        path: "/personalized-recommendations",
      },
      {
        icon: <Enterprise />,
        title: "Enterprise Technology",
        path: "/hostai-forecast",
      },
      {
        icon: <Gaming />,
        title: "Gaming",
        path: "/fraud-detector",
      },
      {
        icon: <Government />,
        title: "Government",
        path: "/document-analysis",
      },
      {
        icon: <Travel />,
        title: "Travel",
        path: "/ui-design-automation",
      },
    ],
  },
  {
    title: "Companies",
    path: "/companies",
  },
  {
    title: "Pricing",
    path: "/pricing",
  },
  {
    title: "Developers",
    path: "/developers",
  },
  {
    title: "Support",
    path: "/support",
  },
  {
    title: "Learn",
    iconClosed: <ExpandMore style={{ width: "20px", height: "20px" }} />,
    iconOpened: <ExpandLess style={{ width: "20px", height: "20px" }} />,

    subNav: [
      {
        title: "Training & Certifications",
        path: "/chatbots",
        icon: <TrainingCertification />,
      },
      {
        title: "Getting Started",
        path: "/getting-started",
        icon: <GetStarted />,
      },
      {
        title: "Documentation",
        path: "/noise-cancelling",
        icon: <Documentation />,
      },
      {
        title: "Blog",
        path: "/blog",
        icon: <Blog />,
      },
      {
        title: "Case Studies",
        path: "/text-to-speech",
        icon: <CaseStudies />,
      },
      {
        title: "Platform Overview",
        path: "/text-to-speech",
        icon: <PlatformOverview />,
      },
      {
        title: "Trust Center",
        path: "/text-to-speech",
        icon: <TrustCenter />,
      },
      {
        title: "Webinars",
        path: "/text-to-speech",
        icon: <Webinars />,
      },
      {
        title: "News",
        path: "/news",
        icon: <News />,
      },
    ],
  },
];
